import React from 'react';
import Button from './Button';
import Select from './Select';
import { useAction, useForm } from '../hooks';
import { useHistory} from 'react-router-dom';

const initFormSearchData = {
  q: '',
  application_status: '',
  transaction_type: ''
}

const Search = () => {

  const getList = useAction('payment.getList')
  const [searchFormData,  searchFormAction] = useForm(initFormSearchData)
  const history = useHistory()

  const handleSearch = e => {
    e.preventDefault()
    getList(searchFormData, () => {
      history.push({
        pathname: '/',
        search: `q=${searchFormData.q}`
      })
    })
  }

  const onChangeSelect = e => {
    initFormSearchData.application_status = e.target.value;
    getList(searchFormData, () => {
      history.push({
        pathname: '/',
        search: `application_status=${initFormSearchData.application_status}`
      })
    })
  }

  const onChangeSelectTransactionType = e => {
    initFormSearchData.transaction_type = e.target.value;
    getList(searchFormData, () => {
      history.push({
        pathname: '/',
        search: `q=${initFormSearchData.transaction_type}`
      })
    })
  }

  return (
    <>
    <form className="flex flex-col xl:flex-row space-y-2 xl:space-y-0 xl:space-x-2 lg:flex-row  lg:space-y-0 lg:space-x-2 spaace-x-0   w-full items-center"  onSubmit={handleSearch}>
      <Select 
          options={[
            { value: 'FOR ASSESSMENT', label: 'FOR ASSESSMENT'},
            { value: 'FOR APPOINTMENT', label: 'FOR APPOINTMENT'},
            { value: 'FOR APPEARANCE', label: 'FOR APPEARANCE'},
            { value: 'FOR PAYMENT', label: 'FOR PAYMENT'},
            { value: 'FOR HEARING', label: 'FOR HEARING'},
            { value: 'RELEASED', label: 'RELEASED' },
            { value: 'FOR RESUBMISSION', label: 'FOR RESUBMISSION'},
          ]}
          onChange={onChangeSelect}
          value={initFormSearchData.application_status}
        />
        <Select 
          options={[
            { value: 'New CPC', label: 'New CPC' }
          ]}
          onChange={onChangeSelectTransactionType}
          value={initFormSearchData.transaction_type}
        />
      <input  name="q" onChange={searchFormAction.onChange} value={searchFormData.q} className="w-full" placeholder="Search by Case No."/>
      <Button className="!w-auto self-end">Search</Button>
    </form> 
    </>
  )
}

export default Search